var map = {
	"./avatar_01.png": "cb7a",
	"./avatar_02.png": "46da",
	"./avatar_03.png": "0503",
	"./avatar_04.png": "a949",
	"./avatar_05.png": "b18b",
	"./avatar_06.png": "83a6",
	"./avatar_07.png": "cd6a",
	"./avatar_08.png": "8797",
	"./avatar_09.png": "299f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49d6";